import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header";
import Login from "./components/Login";
import Home from "./pages/Home";
import SheetList from "./pages/SheetList";
import SheetView from "./pages/SheetView";
import SheetEdit from "./pages/SheetEdit";
import SheetAdd from "./pages/SheetAdd";
import "./index.css";
import theme from "./theme";

import Page404 from "./pages/Page404";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <Header />
        <Box sx={{ paddingTop: "20px", paddingLeft: "10px", paddingRight: "10px" }}>
          <Routes>
            <Route path="/" element={<><Home /><SheetList /></>} />

            <Route path="/sheet/" element={<SheetList />} />
            <Route path="/sheet/add" element={<Login><SheetAdd /></Login>} />
            <Route path="/sheet/:sheetId" element={<SheetView />} />
            <Route path="/sheet/:sheetId/edit" element={<Login><SheetEdit /></Login>} />

            <Route path="*" element={<Page404 />} />
          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);
